import React from "react"

export const FacebookIcon = ({ width = 12, height = 12, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#c09a52"
      d="M15.997 3.985h2.191V.169C17.81.117 16.51 0 14.996 0c-3.159 0-5.323 1.987-5.323 5.639V9H6.187v4.266h3.486V24h4.274V13.267h3.345l.531-4.266h-3.877V6.062c.001-1.233.333-2.077 2.051-2.077z"
    ></path>
  </svg>
)

export const GoogleIcon = ({ width = 14, height = 14, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#c09a52">
      <path d="M21.823 9h-2.187v2.177h-2.177v2.187h2.177v2.177h2.187v-2.177H24v-2.187h-2.177zM14.703 12.174c0-.491-.051-.87-.122-1.248h-7.08v2.578h4.257c-.748 4.7-8.902 4.309-8.902-1.504 0-4.186 4.94-6.173 7.633-3.582l2.036-1.954C7.907 2.138 0 5.38 0 12c0 9.68 14.703 10.253 14.703.174z"></path>
    </g>
  </svg>
)

export const TwitterIcon = ({ width = 13, height = 11, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-0.25 -0.25 1109.5 901.5"
    {...props}
  >
    <path
      fill="#c09a52"
      stroke="#5da8dc"
      strokeWidth="0.5"
      d="M741 .2V0h52l19 3.8c12.667 2.467 24.167 5.7 34.5 9.7 10.334 4 20.334 8.667 30 14 9.667 5.333 18.434 10.767 26.301 16.3 7.8 5.467 14.8 11.267 21 17.4C929.933 67.4 939.5 69 952.5 66s27-7.167 42-12.5 29.834-11.333 44.5-18c14.667-6.667 23.601-10.9 26.801-12.7 3.133-1.866 4.8-2.866 5-3l.199-.3 1-.5 1-.5 1-.5 1-.5.2-.3.3-.2.301-.2.199-.3 1-.3 1-.2-.199 1.5-.301 1.5-.5 1.5-.5 1.5-.5 1-.5 1-.5 1.5c-.333 1-.666 2.333-1 4-.333 1.667-3.5 8.333-9.5 20S1051 73 1042 85s-17.066 21.066-24.199 27.2c-7.2 6.2-11.967 10.533-14.301 13-2.333 2.533-5.166 4.866-8.5 7l-5 3.3-1 .5-1 .5-.199.3-.301.2-.3.2-.2.3-1 .5-1 .5-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.3.2-.2.3h5l28-6c18.667-4 36.5-8.833 53.5-14.5l27-9 3-1 1.5-.5 1-.5 1-.5 1-.5 1-.5 2-.3 2-.2v2l-.5.2-.5.3-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.3.2-.2.3-.199.3-.301.2-.5 1-.5 1-.3.2c-.133.2-4.366 5.866-12.7 17-8.333 11.2-12.833 16.866-13.5 17-.666.2-1.6 1.2-2.8 3-1.133 1.866-8.2 9.3-21.2 22.3s-25.732 24.566-38.199 34.7c-12.533 10.2-18.867 22.733-19 37.6-.2 14.8-.967 31.534-2.301 50.2-1.333 18.667-3.833 38.833-7.5 60.5-3.666 21.667-9.333 46.167-17 73.5-7.666 27.333-17 54-28 80s-22.5 49.333-34.5 70-23 38.167-33 52.5-20.166 27.833-30.5 40.5c-10.333 12.667-23.399 26.934-39.199 42.8-15.867 15.8-24.533 24.467-26 26-1.533 1.467-8.066 6.934-19.601 16.4-11.466 9.533-23.8 19.066-37 28.6-13.133 9.467-25.2 17.367-36.2 23.7s-24.266 13.566-39.8 21.7C630.734 840.4 614 848 596 855s-37 13.5-57 19.5-39.333 10.667-58 14c-18.666 3.333-39.833 6.167-63.5 8.5l-35.5 3.5v.5h-65v-.5l-8.5-.5c-5.666-.333-10.333-.667-14-1-3.666-.333-17.5-2.167-41.5-5.5s-42.833-6.667-56.5-10c-13.666-3.333-34-9.667-61-19s-50.1-18.767-69.3-28.3c-19.133-9.467-31.133-15.467-36-18-4.8-2.467-10.2-5.533-16.2-9.2l-9-5.5-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3-.301-.2-.3-.2-.2-.3-.199-.3L.5 800H0v-2l1 .2 1 .3 4.5.5c3 .333 11.167.833 24.5 1.5 13.334.667 27.5.667 42.5 0s30.334-2.167 46-4.5c15.667-2.333 34.167-6.333 55.5-12 21.334-5.667 40.934-12.4 58.801-20.2 17.8-7.866 30.466-13.733 38-17.6 7.466-3.8 18.866-10.867 34.199-21.2l23-15.5.2-.3.3-.2.301-.2.199-.3.2-.3.3-.2.301-.2.199-.3 1-.3 1-.2.2-1 .3-1 .301-.2.199-.3-8-.5c-5.333-.333-10.5-.667-15.5-1s-12.833-1.833-23.5-4.5c-10.666-2.667-22.166-6.667-34.5-12-12.333-5.333-24.333-11.667-36-19-11.666-7.333-20.1-13.434-25.3-18.3-5.133-4.801-11.8-11.6-20-20.4-8.133-8.866-15.2-17.967-21.2-27.3s-11.733-20.101-17.199-32.3L124.5 551l-.5-1.5-.5-1.5-.3-1-.2-1 1.5.2 1.5.3 11 1.5c7.334 1 18.834 1.333 34.5 1 15.667-.333 26.5-1 32.5-2s9.667-1.667 11-2l2-.5 2.5-.5 2.5-.5.2-.3.3-.2.301-.2.199-.3-2-.5-2-.5-2-.5-2-.5-2-.5c-1.333-.333-3.666-1-7-2-3.333-1-12.333-4.667-27-11-14.666-6.333-26.333-12.5-35-18.5a241.7 241.7 0 01-24.8-19.7c-7.8-7.2-16.366-16.467-25.7-27.8-9.333-11.333-17.666-24.5-25-39.5-7.333-15-12.833-29.333-16.5-43a232.143 232.143 0 01-7.199-41.5L43 316l1 .2 1 .3 1 .5 1 .5 1 .5 1 .5 15.5 7c10.334 4.667 23.167 8.667 38.5 12 15.334 3.333 24.5 5.167 27.5 5.5l4.5.5h9l-.199-.3-.301-.2-.3-.2-.2-.3-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3-.301-.2-.3-.2-.2-.3-1-.5-1-.5-.199-.3c-.2-.134-3.067-2.267-8.601-6.4-5.467-4.2-11.2-9.633-17.2-16.3s-12-13.667-18-21A162.158 162.158 0 0177 271c-4.666-8.333-9.6-18.934-14.8-31.8-5.133-12.8-9.033-25.7-11.7-38.7-2.666-13-4.166-25.833-4.5-38.5-.333-12.667 0-23.5 1-32.5s3-19.167 6-30.5 7.334-23.333 13-36l8.5-19 .5-1.5.5-1.5.301-.2.199-.3.2-.3.3-.2.301.2.199.3.2.3.3.2.301.2.199.3.2.3.3.2.5 1 .5 1 .301.2.199.3 13.5 15c9 10 19.667 21.167 32 33.5 12.334 12.333 19.167 18.733 20.5 19.2 1.334.533 3 2.066 5 4.6 2 2.467 8.667 8.367 20 17.7 11.334 9.333 26.167 20.167 44.5 32.5 18.334 12.333 38.667 24.5 61 36.5 22.334 12 46.334 22.833 72 32.5 25.667 9.667 43.667 16 54 19 10.334 3 28 6.833 53 11.5s43.834 7.667 56.5 9c12.667 1.333 21.334 2.1 26 2.3l7 .2-.199-1.5-.301-1.5-2-12.5c-1.333-8.333-2-20-2-35s1.167-28.833 3.5-41.5c2.334-12.667 5.834-25.5 10.5-38.5 4.667-13 9.234-23.434 13.7-31.3 4.534-7.8 10.467-16.7 17.8-26.7 7.334-10 16.834-20.333 28.5-31 11.667-10.667 25-20.167 40-28.5s28.834-14.667 41.5-19c12.667-4.333 23.334-7.167 32-8.5 8.667-1.333 13-2.1 13-2.3z"
    ></path>
  </svg>
)

export const HeartIcon = ({ width = 27, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 27 24"
    {...props}
  >
    <defs>
      <radialGradient
        id="z7k2ho7zkb"
        cx="20.498%"
        cy="19.211%"
        r="54.265%"
        fx="20.498%"
        fy="19.211%"
        gradientTransform="matrix(.54366 .79149 -.70405 .61118 .229 -.088)"
      >
        <stop offset="0%" stopColor="#FFBFBF"></stop>
        <stop offset="100%" stopColor="#FE2020"></stop>
      </radialGradient>
      <path
        id="ynv0yrntua"
        d="M1312.33 160c-2.25-.012-4.39 1.05-5.84 2.9-1.44-1.863-3.586-2.928-5.84-2.9-4.225 0-7.65 3.68-7.65 8.22 0 7.78 12.636 15.375 13.149 15.669a.58.58 0 00.683 0c.512-.294 13.149-7.78 13.149-15.669 0-4.54-3.426-8.22-7.65-8.22z"
      ></path>
    </defs>
    <g fill="none" fillRule="nonzero" transform="translate(-1293 -160)">
      <use fill="#FF3946" xlinkHref="#ynv0yrntua"></use>
      <use fill="url(#z7k2ho7zkb)" xlinkHref="#ynv0yrntua"></use>
    </g>
  </svg>
)

export const SearchIcon = ({
  width = 24,
  height = 24,
  hover = false,
  ...props
}) => {
  return hover ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <filter id="d7j3v4eypa">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 0 0.211765 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" filter="url(#d7j3v4eypa)">
        <path
          fill="#000"
          fillRule="nonzero"
          d="M10.935 0c6.03 0 10.935 4.905 10.935 10.935a10.88 10.88 0 01-2.448 6.887L24 22.4 22.4 24l-4.578-4.578a10.88 10.88 0 01-6.887 2.448C4.905 21.87 0 16.965 0 10.935S4.905 0 10.935 0zm0 19.608c4.782 0 8.673-3.89 8.673-8.673 0-4.782-3.89-8.673-8.673-8.673-4.782 0-8.673 3.891-8.673 8.673s3.891 8.673 8.673 8.673z"
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <filter id="pr47501mba">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.749020 0 0 0 0 0.600000 0 0 0 0 0.341176 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" filter="url(#pr47501mba)">
        <path
          fill="#000"
          fillRule="nonzero"
          d="M10.935 0c6.03 0 10.935 4.905 10.935 10.935a10.88 10.88 0 01-2.448 6.887L24 22.4 22.4 24l-4.578-4.578a10.88 10.88 0 01-6.887 2.448C4.905 21.87 0 16.965 0 10.935S4.905 0 10.935 0zm0 19.608c4.782 0 8.673-3.89 8.673-8.673 0-4.782-3.89-8.673-8.673-8.673-4.782 0-8.673 3.891-8.673 8.673s3.891 8.673 8.673 8.673z"
        ></path>
      </g>
    </svg>
  )
}

export const LocationIcon = ({
  width = 24,
  height = 24,
  hover = false,
  ...props
}) => {
  return hover ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <filter id="9fui3y200a">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 0 0.211765 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" filter="url(#9fui3y200a)">
        <g fillRule="nonzero">
          <path
            fill="#000"
            d="M11.703 0C6.358 0 2.01 4.349 2.01 9.694c0 6.55 5.647 11.068 9.021 13.768l.673.538.673-.538c3.374-2.7 9.022-7.218 9.022-13.768C21.398 4.35 17.048 0 11.703 0zm0 21.237c-3.91-3.184-7.54-6.729-7.54-11.542 0-4.158 3.382-7.54 7.54-7.54 4.158 0 7.54 3.382 7.54 7.54 0 4.813-3.63 8.358-7.54 11.542z"
          ></path>
          <path
            fill="#BF9957"
            d="M11.703 7.54a2.157 2.157 0 00-2.154 2.154c0 1.188.966 2.155 2.154 2.155s2.154-.967 2.154-2.155a2.157 2.157 0 00-2.154-2.154z"
          ></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <filter id="b6msecngla">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.749020 0 0 0 0 0.600000 0 0 0 0 0.341176 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" filter="url(#b6msecngla)">
        <g fillRule="nonzero">
          <path
            fill="#000"
            d="M11.703 0C6.358 0 2.01 4.349 2.01 9.694c0 6.55 5.647 11.068 9.021 13.768l.673.538.673-.538c3.374-2.7 9.022-7.218 9.022-13.768C21.398 4.35 17.048 0 11.703 0zm0 21.237c-3.91-3.184-7.54-6.729-7.54-11.542 0-4.158 3.382-7.54 7.54-7.54 4.158 0 7.54 3.382 7.54 7.54 0 4.813-3.63 8.358-7.54 11.542z"
          ></path>
          <path
            fill="#BF9957"
            d="M11.703 7.54a2.157 2.157 0 00-2.154 2.154c0 1.188.966 2.155 2.154 2.155s2.154-.967 2.154-2.155a2.157 2.157 0 00-2.154-2.154z"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export const SearchDropdownIcon = ({ width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <filter id="xbgfego0ia">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 0 0.211765 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#xbgfego0ia)"
      transform="translate(-860 -44)"
    >
      <g fill="#2C2E36" fillRule="nonzero">
        <path d="M872 53.846c-1.188 0-2.155.966-2.155 2.154s.967 2.154 2.155 2.154c1.187 0 2.154-.966 2.154-2.154s-.968-2.154-2.154-2.154zm-.707-9.139l-3.229 3.227a1 1 0 00.707 1.707h6.457a1 1 0 00.707-1.707l-3.228-3.227a1 1 0 00-1.414 0zM872.707 67.294l3.229-3.227a1 1 0 00-.707-1.707h-6.457a1 1 0 00-.707 1.707l3.228 3.227a1 1 0 001.414 0z"></path>
      </g>
    </g>
  </svg>
)

export const SearchDropdownHoverIcon = ({
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <filter id="ufz16e1a4a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.749020 0 0 0 0 0.600000 0 0 0 0 0.341176 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#ufz16e1a4a)"
      transform="translate(-323 -20)"
    >
      <g fill="#BF9957" fillRule="nonzero">
        <path d="M334.644 20.846c-1.188 0-2.155.966-2.155 2.154s.967 2.154 2.155 2.154c1.187 0 2.154-.966 2.154-2.154s-.968-2.154-2.154-2.154zM335.351 34.294l3.229-3.227a1 1 0 00-.707-1.707h-6.457a1 1 0 00-.707 1.707l3.228 3.227a1 1 0 001.414 0z"></path>
      </g>
    </g>
  </svg>
)

export const DropdownIcon = ({ width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#2C2E36"
      fillRule="nonzero"
      d="M12.705 14.114l3.229-3.227a1.002 1.002 0 00-.707-1.708H8.77a1 1 0 00-.707 1.708l3.228 3.227a1 1 0 001.414 0z"
    ></path>
  </svg>
)

export const ArrowIcon = ({ width = 64, height = 64, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <circle cx="32" cy="32" r="32" fill="#2C2E36"></circle>
      <path
        stroke="#FFF"
        strokeWidth="1.829"
        d="M18.286 32.457h25.6M38.4 24.686l7.315 7.445-7.315 7.184"
      ></path>
    </g>
  </svg>
)

export const CalenderIcon = ({ width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#2C2E36" fillRule="nonzero">
      <path d="M18.008 4.046h-.399V3.028c0-.62-.42-1.018-1.018-1.018-.599 0-1.018.399-1.018 1.018v1.018H8.946V3.028c0-.62-.4-1.018-1.018-1.018-.619 0-1.018.399-1.018 1.018v1.018h-.918c-1.936 0-3.573 1.636-3.573 3.573v10.798c0 1.937 1.637 3.573 3.573 3.573h12.016c1.936 0 3.573-1.636 3.573-3.573V7.62c0-1.937-1.637-3.573-3.573-3.573zM5.992 6.082h12.016c.819 0 1.537.718 1.537 1.537v1.417H4.455V7.619c0-.819.718-1.537 1.537-1.537zm12.016 13.853H5.992c-.819 0-1.537-.72-1.537-1.537v-7.326h15.07v7.326c.02.818-.698 1.537-1.517 1.537z"></path>
      <path d="M10.064 12.28h-.819c-.519 0-.818.4-.818.818v.919c0 .519.4.818.818.818h.819c.519 0 .818-.4.818-.818v-.819c.1-.499-.3-.918-.818-.918zm4.691 0h-.819c-.519 0-.818.4-.818.818v.919c0 .519.399.818.818.818h.819c.519 0 .818-.4.818-.818v-.819c0-.499-.42-.918-.818-.918zm-4.691 3.972h-.819c-.519 0-.818.4-.818.819v.818c0 .519.4.818.818.818h.819c.519 0 .818-.399.818-.818v-.818c.1-.4-.3-.819-.818-.819zm4.676 0h-.82c-.518 0-.818.4-.818.819v.818c0 .519.4.818.819.818h.818c.52 0 .819-.399.819-.818v-.818c.1-.4-.3-.819-.819-.819z"></path>
    </g>
  </svg>
)

export const VLine = ({ width = 1, height = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 1 32"
    {...props}
  >
    <path fill="#e8edf2" fillRule="evenodd" d="M0 0h1v32H0z"></path>
  </svg>
)

export const ArrowHoverIcon = ({ width = 64, height = 64, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    {...props}
  >
    <defs>
      <linearGradient
        id="xl37d0xk1a"
        x1="-22.962%"
        x2="87.22%"
        y1="16.998%"
        y2="73.865%"
      >
        <stop offset="0%" stopColor="#BB9149"></stop>
        <stop offset="100%" stopColor="#DAC27C"></stop>
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <circle cx="32" cy="32" r="32" fill="url(#xl37d0xk1a)"></circle>
      <path
        stroke="#FFF5E4"
        strokeWidth="1.829"
        d="M18.286 32.457h25.6M38.4 24.686l7.315 7.445-7.315 7.184"
      ></path>
    </g>
  </svg>
)

export const PinPoint = ({ width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#2C2E36" fillRule="nonzero">
      <path d="M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"></path>
      <path d="M23 11h-2.059A9.011 9.011 0 0013 3.059V1a1 1 0 00-2 0v2.059A9.011 9.011 0 003.059 11H1a1 1 0 000 2h2.059A9.011 9.011 0 0011 20.941V23a1 1 0 002 0v-2.059A9.011 9.011 0 0020.941 13H23a1 1 0 000-2zm-11 8c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"></path>
    </g>
  </svg>
)

export const CloseBtn = ({ width = 31, height = 31, hover, ...props }) => {
  return hover ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 31 31"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="31" height="31" fill="#FF3946" rx="4"></rect>
        <path
          fill="#FFF"
          fillOpacity="0.801"
          d="M10.293 10.293a1 1 0 011.414 0l3.535 3.535 3.536-3.535a1 1 0 011.414 1.414l-3.535 3.535 3.535 3.536a1 1 0 01.084 1.32l-.084.094a1 1 0 01-1.414 0l-3.536-3.535-3.535 3.535a1 1 0 01-1.414-1.414l3.535-3.536-3.535-3.535a1 1 0 01-.083-1.32z"
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 31 31"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="31" height="31" fill="#2C2E36" opacity="0.8" rx="4"></rect>
        <path
          fill="#FFF"
          fillOpacity="0.801"
          d="M10.293 10.293a1 1 0 011.414 0l3.535 3.535 3.536-3.535a1 1 0 011.414 1.414l-3.535 3.535 3.535 3.536a1 1 0 01.084 1.32l-.084.094a1 1 0 01-1.414 0l-3.536-3.535-3.535 3.535a1 1 0 01-1.414-1.414l3.535-3.536-3.535-3.535a1 1 0 01-.083-1.32z"
        ></path>
      </g>
    </svg>
  )
}

export const CancelBtn = ({ width = 32, height = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd" opacity="0.502">
      <circle cx="16" cy="16" r="16" fill="#EFEFEF"></circle>
      <path
        fill="#2C2E36"
        d="M20.42 10.52l1.06 1.06L17.06 16l4.42 4.42-1.06 1.06L16 17.06l-4.42 4.42-1.06-1.06L14.939 16l-4.42-4.42 1.062-1.06L16 14.939l4.42-4.42z"
      ></path>
    </g>
  </svg>
)

export const UploadPhoto = ({ width = 40, height = 40, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#BF9957"
        d="M4.808 4.286h7.78V7.11h-7.78zm14.724 17.221a4.896 4.896 0 11-9.792 0 4.897 4.897 0 019.792 0z"
      ></path>
      <path
        fill="#A5A5A5"
        d="M36.243 7.978H3.707A2.707 2.707 0 001 10.684v21.648c0 1.5 1.216 2.71 2.707 2.71h32.536a2.705 2.705 0 002.705-2.71V10.684a2.702 2.702 0 00-2.705-2.706zm-4.713 2.196h3.295a1.776 1.776 0 010 3.551H31.53a1.776 1.776 0 110-3.551zm-16.784 21.6C9.075 31.775 4.48 27.18 4.48 21.51c0-5.669 4.595-10.266 10.266-10.266 5.67 0 10.265 4.597 10.265 10.266 0 5.67-4.595 10.265-10.265 10.265zm22.168-1.878H33.09v3.9h-3.33v-3.9h-3.875v-3.333h3.875V22.77h3.33v3.793h3.824v3.333z"
      ></path>
    </g>
  </svg>
)

export const UploadVideo = ({ width = 40, height = 40, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    {...props}
  >
    <g fill="none" fillRule="nonzero" transform="translate(1 3)">
      <path fill="#BF9957" d="M28.945 21.152v6.828L38 32.805V16.328z"></path>
      <circle cx="20.039" cy="6.68" r="6.68" fill="#BF9957"></circle>
      <circle cx="6.68" cy="6.68" r="6.68" fill="#BF9957"></circle>
      <path
        fill="#A5A5A5"
        d="M0 15.586v17.96h26.719v-17.96H0zm19.029 11.126h-3.823v3.9h-3.33v-3.9H8V23.38h3.875v-3.794h3.33v3.794h3.824v3.332z"
      ></path>
      <path
        fill="#FFF"
        d="M22 18v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1zM2 18v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1H3a1 1 0 00-1 1zm0 12v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1H3a1 1 0 00-1 1zm20 0v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1z"
      ></path>
    </g>
  </svg>
)

export const PlayIcon = ({ width = 124, height = 124, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 124 124"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="62" cy="62" r="62" fill="#FF3951"></circle>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M52.059 35.235C47.056 32.339 43 34.71 43 40.53v42.936c0 5.824 4.056 8.194 9.059 5.3l37.188-21.522c5.004-2.897 5.004-7.59 0-10.487L52.059 35.235z"
      ></path>
    </g>
  </svg>
)

export const FacebookColorIcon = ({ width = 32, height = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="32" height="32" fill="#3B5999" rx="5.333"></rect>
      <path
        fill="#FFF"
        d="M21.586 6.004L18.947 6c-2.964 0-4.88 2.007-4.88 5.113v2.358h-2.652a.42.42 0 00-.415.424v3.416a.42.42 0 00.415.424h2.653v8.62c0 .233.185.423.415.423h3.46a.42.42 0 00.416-.424v-8.62h3.101c.23 0 .415-.189.415-.423l.001-3.416a.43.43 0 00-.121-.3.41.41 0 00-.294-.124H18.36v-1.999c0-.96.224-1.448 1.449-1.448h1.777a.42.42 0 00.415-.424V6.428a.42.42 0 00-.414-.424z"
      ></path>
    </g>
  </svg>
)

export const TwitterColorIcon = ({ width = 32, height = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="32" height="32" fill="#55ACEE" rx="5.333"></rect>
      <path
        fill="#FFF"
        d="M27 10.011a8.624 8.624 0 01-2.474.677 4.317 4.317 0 001.894-2.374 8.69 8.69 0 01-2.737 1.042A4.305 4.305 0 0020.538 8a4.3 4.3 0 00-4.196 5.27 12.245 12.245 0 01-8.879-4.485 4.287 4.287 0 001.333 5.73 4.311 4.311 0 01-1.95-.538v.053a4.3 4.3 0 003.454 4.21 4.36 4.36 0 01-1.135.15c-.278 0-.547-.027-.81-.08a4.307 4.307 0 004.023 2.982 8.662 8.662 0 01-5.35 1.835c-.348 0-.69-.02-1.028-.059A12.209 12.209 0 0012.603 25c7.925 0 12.257-6.542 12.257-12.215l-.015-.556A8.559 8.559 0 0027 10.011z"
      ></path>
    </g>
  </svg>
)

export const PinterestColorIcon = ({ width = 32, height = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect width="32" height="32" fill="#BD081C" rx="5.333"></rect>
      <path
        fill="#FFF"
        d="M24.893 11.395c-.632-4.545-5.188-6.86-10.05-6.317-3.844.428-7.676 3.517-7.835 7.935-.097 2.696.672 4.719 3.254 5.288 1.118-1.966-.36-2.396-.592-3.82-.947-5.823 6.756-9.799 10.791-5.73 2.794 2.817.953 11.48-3.547 10.578-4.311-.86 2.111-7.755-1.33-9.108-2.795-1.101-4.28 3.364-2.954 5.583-.779 3.817-2.454 7.41-1.775 12.196 2.198-1.587 2.94-4.622 3.547-7.788 1.105.668 1.696 1.36 3.105 1.467 5.194.401 8.1-5.155 7.386-10.284z"
      ></path>
    </g>
  </svg>
)

export const RightArrow = ({ width = 48, height = 48, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter id="7i66i6biga">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 0 0.211765 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#7i66i6biga)">
      <path
        stroke="#000"
        strokeWidth="2"
        d="M0 23.885h46.73M39 14.5l9 9.5-9 9.5"
      ></path>
    </g>
  </svg>
)

export const RightHoverArrow = ({ width = 48, height = 48, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter id="o9ws4vqewa">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.752834 0 0 0 0 0.602888 0 0 0 0 0.320317 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#o9ws4vqewa)">
      <path
        stroke="#000"
        strokeWidth="2"
        d="M0 23.885h46.73M39 14.5l9 9.5-9 9.5"
      ></path>
    </g>
  </svg>
)

export const LeftArrow = ({ width = 48, height = 48, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter id="kxg0pu4r2a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 0 0.211765 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#kxg0pu4r2a)">
      <path
        stroke="#000"
        strokeWidth="2"
        d="M48 23.885H1.27M9 14.5L0 24l9 9.5"
      ></path>
    </g>
  </svg>
)

export const LeftHoverArrow = ({ width = 48, height = 48, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <filter id="56vqoxpxva">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.752834 0 0 0 0 0.602888 0 0 0 0 0.320317 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#56vqoxpxva)">
      <path
        stroke="#000"
        strokeWidth="2"
        d="M48 23.885H1.27M9 14.5L0 24l9 9.5"
      ></path>
    </g>
  </svg>
)

export const SubscribeSuccessIcon = ({ width = 42, height = 40, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 42 40"
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFA000"
        d="M40.434 27.781a4.54 4.54 0 01-3.214 1.325H4.54a4.535 4.535 0 01-3.215-1.325l14.816-14.815 2.505 1.815c1.328.98 3.14.98 4.467 0l2.505-1.815L40.434 27.78z"
      ></path>
      <path
        fill="#FFD54F"
        d="M40.887 1.927L25.618 12.966l-2.505 1.815c-1.328.98-3.14.98-4.467 0l-2.505-1.815L.853 1.945A4.51 4.51 0 014.54.057h32.68a4.537 4.537 0 013.668 1.87z"
      ></path>
      <path
        fill="#FFC107"
        d="M.853 1.945l15.288 11.02L1.325 27.782A4.545 4.545 0 010 24.568V4.595a4.486 4.486 0 01.853-2.65zm40.906 2.65v19.972a4.545 4.545 0 01-1.325 3.214L25.618 12.965l15.27-11.039a4.52 4.52 0 01.87 2.67z"
      ></path>
      <circle cx="20.879" cy="30.014" r="9.986" fill="#0B9A2A"></circle>
      <path
        fill="#FAFAFA"
        d="M19.064 34.553a.911.911 0 01-.643-.265l-3.631-3.631a.91.91 0 011.284-1.284l2.99 2.989 5.712-5.712a.908.908 0 011.283 1.284l-6.354 6.354c-.17.17-.4.265-.641.265z"
      ></path>
    </g>
  </svg>
)

export const SubscribeErrorIcon = ({ width = 42, height = 40, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 42 40"
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFA000"
        d="M40.434 27.781a4.54 4.54 0 01-3.214 1.325H4.54a4.535 4.535 0 01-3.215-1.325l14.816-14.815 2.505 1.815c1.328.98 3.14.98 4.467 0l2.505-1.815L40.434 27.78z"
      ></path>
      <path
        fill="#FFD54F"
        d="M40.887 1.927L25.618 12.966l-2.505 1.815c-1.328.98-3.14.98-4.467 0l-2.505-1.815L.853 1.945A4.51 4.51 0 014.54.057h32.68a4.537 4.537 0 013.668 1.87z"
      ></path>
      <path
        fill="#FFC107"
        d="M.853 1.945l15.288 11.02L1.325 27.782A4.545 4.545 0 010 24.568V4.595a4.486 4.486 0 01.853-2.65zm40.906 2.65v19.972a4.545 4.545 0 01-1.325 3.214L25.618 12.965l15.27-11.039a4.52 4.52 0 01.87 2.67z"
      ></path>
      <circle cx="20.879" cy="30.014" r="9.986" fill="#950202"></circle>
      <g fill="#FFE7E7">
        <path d="M24.51 34.553a.91.91 0 01-.642-.265l-7.263-7.261a.91.91 0 01.023-1.285.906.906 0 011.26 0l7.263 7.263a.907.907 0 01-.641 1.548z"></path>
        <path d="M17.248 34.553a.908.908 0 01-.643-1.55l7.263-7.263a.907.907 0 011.283 1.284l-7.262 7.262c-.17.17-.4.267-.641.267z"></path>
      </g>
    </g>
  </svg>
)

export const ReCycle = ({ size = 40 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <g fill="none" fillRule="nonzero">
        <circle cx="20" cy="20" r="20" fill="#FFF"></circle>
        <path
          fill="#2C2E36"
          d="M19.758 21.38c-1.031-.846-1.72-1.89-2.082-2.484l-.27-.508c.095-.101.815-.87 1.126-1.288.393-.524-.176-.997-.176-.997s-1.6-1.597-1.964-1.913c-.364-.317-.784-.141-.784-.141-.766.494-1.56.923-1.608 2.989-.002 1.934 1.47 3.928 3.06 5.472 1.593 1.744 3.781 3.492 5.896 3.49 2.07-.047 2.5-.84 2.995-1.604 0 0 .177-.418-.14-.783-.318-.364-1.918-1.96-1.918-1.96s-.474-.567-1-.176c-.391.292-1.094.942-1.264 1.1 0 0-1.175-.626-1.871-1.197z"
        ></path>
      </g>
    </svg>
  )
}
